<mat-sidenav-container>
  <mat-sidenav #sidenav [mode]="'over'">
    <app-sidenav-content></app-sidenav-content>
  </mat-sidenav>

  <mat-sidenav-content>
    <app-header
      (isHandsetPortraitStatus)="isHandsetPortraitStatus($event)"
      (openSideNav)="sidenav.toggle()"
    ></app-header>
    <!-- <div class="sggs-dashboard-content">
      <div class="small-carousel carousel-wrapper" [class.is-mobile]="isHandsetPortrait">
        <div class="title-banner-wrapper {{bannerClass}}" style="background-image: url('assets/images/{{bannerImage}}');">
          <div class="bani-title">
            {{ activeLanguageTranslations?.title }}
          </div>
        </div>
      </div>
      <div class="padded-content-wrapper" [class.is-mobile]="isHandsetPortrait">
        <div class="static-content-heading-wrapper">{{ activeLanguageTranslations?.title }}</div>
        <div class="static-content-paragraph"> -->
          <!-- <b> {{ activeLanguageTranslations?.sggsProject }} </b> <br />
          {{ activeLanguageTranslations?.subTagLine }} -->
        <!-- </div> -->

        <!-- <div class="static-content-heading-wrapper">{{ activeLanguageTranslations?.theVision }}</div> -->
        <!-- <div class="static-content-paragraph">
          {{ activeLanguageTranslations?.visionParagraphOne  }}
        </div>
      </div>
      <app-footer [isHandsetPortrait]="isHandsetPortrait"></app-footer>
    </div> -->

  <!-- *****************************************************************************************************************************************************   -->
<div class="sggs-dashboard-content">
  <div class="small-carousel carousel-wrapper" style="background-color: #ffffff !important;"
    [class.is-mobile]="isHandsetPortrait">
    <div class="title-container">
      <div class="title-banner-wrapper-new {{bannerClass}}">
        <h1 class="bani-title-new">
          Articles
        </h1>
        <p class="bani-title-detail-new">
          The Guru Granth Sahib Project is a global initiative dedicated to making the infinite wisdom of the Guru
          Granth Sahib accessible to English and Panjabi speakers worldwide.
        </p>
      </div>
      <div class="article-Header-cards">
        <div>
          <img class="articleHeaderCardImg" src="../../../assets/images/articalPageHead.png" alt="Artical Head Image"
            srcset="">
        </div>
        <div class="articleHeader-cards-wrapper">
          <p class="articleHeaderHeadline fw-bold">Article Headline</p>
          <p class="articleHeaderAuthorName">Author Name</p>
        </div>
      </div>
    </div>
    <div><img style="min-height: 70px;" src="../../../assets/project/images/Border--Zigzag-bottom--TGGSP-01.svg" alt="Zigzag Bottom Border">
    </div>
  </div>

  <div class="article-content">
    <div class="cards-container">
      <div class="article-cards"
        *ngFor="let article of repeatArticalCard.slice(0, firstDisplayOnlyCards + 1); let i = index"
        (click)="openArticle(article)">
        <div>
          <img class="articleCardImg" src="../../../assets/images/articalPageCard.png" alt="{{article}} image" srcset="">
        </div>
        <div class="article-cards-wrapper">
          <p class="articleHeadline fw-bold">Article Headline</p>
          <p class="articleAuthorName">Author Name</p>
        </div>
      </div>
    </div>

    <div class="viewMoreContainer" [ngClass]="{ 'hidden' : repeatArticalCard.length <= 6}">
      <button type="button" class="viewMoreBtn"
        (click)="updateCardDisplayLimit(viewMoreNtnName)">{{viewMoreNtnName}}</button>
    </div>
  </div>

  <!-- <section class="subForNewsletterSection">
    <div class="subForNewsletterWrapper">
      <h2 class="subForNewsletterTitle">Subscribe to the Newsletter</h2>
      <p class="subForNewsletterText">Get monthly releases delivered right to your inbox.</p>
      <form class="subForNewsletterForm">
        <input type="text" placeholder="Name" required />
        <input type="email" placeholder="Email Address" required />
        <button type="submit" class="newsletterSubBtn">Subscribe</button>
      </form>
    </div>
  </section> -->


  <div class="my-5">
    <app-newsletter></app-newsletter>
  </div>
  <app-footer [isHandsetPortrait]="isHandsetPortrait"></app-footer>

  <!-- *****************************************************************************************************************************************************   -->
</div>
</mat-sidenav-content>
</mat-sidenav-container>